import React from 'react';
import { Grid, Typography, SvgIcon } from '@material-ui/core';
import { useStyles } from './StatusBadge.styles';

interface StatusBadgeProps {
  icon: React.ComponentType<any>;
  label: string;
  variant: 'success' | 'danger';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ icon, label, variant }) => {
  const classes = useStyles();

  return (
    <Grid className={[classes.statusBadge, variant].join(' ')} container item>
      <SvgIcon className="icon" component={icon} viewBox="0 0 24 24" />
      <Typography className="label">{label}</Typography>
    </Grid>
  );
};

export default StatusBadge;
